import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';
import { environment } from 'src/environments/environment';
import { IAsset, IAssetCategory, IAssetRecord } from '../../models/asset.model';
import { IPagination } from 'src/app/common/model/util.model';

@Injectable({
  providedIn: 'root'
})
export class AssetService {
  constructor(private http: HttpClient) {}

  public getAllAssets(): Observable<ISibasiHTTPResponse<IAsset[]>> {
    return this.http.get<ISibasiHTTPResponse<IAsset[]>>(
      `${environment.api_url}asset/all`
    );
  }
  public getAssetById(assetId: string): Observable<ISibasiHTTPResponse<IAsset>> {
    return this.http.get<ISibasiHTTPResponse<IAsset>>(
      `${environment.api_url}asset/one/${assetId}`
    );
  }

  public createAsset(asset: IAsset): Observable<ISibasiHTTPResponse<IAsset>> {
    return this.http.post<ISibasiHTTPResponse<IAsset>>(
      `${environment.api_url}asset`,
      asset
    );
  }

  public deleteAssetId(assetId: string) {
    return this.http.delete(`${environment.api_url}asset/delete/${assetId}`);
  }

  public updateAsset(
    asset: IAsset,
    assetId: string | undefined
  ): Observable<ISibasiHTTPResponse<IAsset>> {
    return this.http.post<ISibasiHTTPResponse<IAsset>>(
      `${environment.api_url}asset/update/${assetId}`,
      asset
    );
  }
  getAllAssetsCount(): Observable<ISibasiHTTPResponse<number>> {
    return this.http.get<ISibasiHTTPResponse<number>>(
      `${environment.api_url}asset/all/count`
    );
  }

  getSearchedAssetsCount(searchParam: string): Observable<ISibasiHTTPResponse<number>> {
    return this.http.post<ISibasiHTTPResponse<number>>(
      `${environment.api_url}asset/all/count`,
      { searchParam }
    );
  }

  getPaginatedAssets(
    pagination?: any
  ): Observable<ISibasiHTTPResponse<IPagination<IAsset[]>>> {
    return this.http.post<ISibasiHTTPResponse<IPagination<IAsset[]>>>(
      `${environment.api_url}asset/paginated`,
      pagination ? pagination : {}
    );
  }

  getCategoryFilteredAssets(
    categoryId: string,
    pagination?: any
  ): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}asset/paginated/category/${categoryId}`,
      pagination ? pagination : {}
    );
  }

  /* ***************************************Asset Category ****************************************/

  public createCategory(
    category: IAssetCategory
  ): Observable<ISibasiHTTPResponse<IAssetCategory>> {
    return this.http.post<ISibasiHTTPResponse<IAssetCategory>>(
      `${environment.api_url}asset/category`,
      category
    );
  }

  public updateCategory(
    category: IAssetCategory,
    categoryId: string | undefined
  ): Observable<ISibasiHTTPResponse<IAssetCategory>> {
    return this.http.post<ISibasiHTTPResponse<IAssetCategory>>(
      `${environment.api_url}asset/category/update/${categoryId}`,
      category
    );
  }

  public getAllCategories(): Observable<ISibasiHTTPResponse<IAssetCategory[]>> {
    return this.http.get<ISibasiHTTPResponse<IAssetCategory[]>>(
      `${environment.api_url}asset/category/all`
    );
  }
  public getPaginatedCategories(
    pagination?: any
  ): Observable<ISibasiHTTPResponse<IPagination<IAssetCategory[]>>> {
    return this.http.post<ISibasiHTTPResponse<IPagination<IAssetCategory[]>>>(
      `${environment.api_url}asset/category/paginated`,
      pagination
    );
  }

  public getCategoryById(
    categoryId: string
  ): Observable<ISibasiHTTPResponse<IAssetCategory>> {
    return this.http.get<ISibasiHTTPResponse<IAssetCategory>>(
      `${environment.api_url}asset/category/one/${categoryId}`
    );
  }

  public deleteCategory(
    categoryId: string | undefined
  ): Observable<ISibasiHTTPResponse<IAssetCategory>> {
    return this.http.delete<ISibasiHTTPResponse<IAssetCategory>>(
      `${environment.api_url}asset/category/delete/${categoryId}`
    );
  }
  /* ***************************************Asset Record ****************************************/

  public createAssetRecord(
    history: IAssetRecord
  ): Observable<ISibasiHTTPResponse<IAssetRecord>> {
    return this.http.post<ISibasiHTTPResponse<IAssetRecord>>(
      `${environment.api_url}asset/history`,
      history
    );
  }

  public updateAssetRecord(
    history: IAssetRecord,
    historyId: string | undefined
  ): Observable<ISibasiHTTPResponse<IAssetRecord>> {
    return this.http.post<ISibasiHTTPResponse<IAssetRecord>>(
      `${environment.api_url}asset/history/update/${historyId}`,
      history
    );
  }

  public getAllAssetRecords(): Observable<ISibasiHTTPResponse<IAssetRecord[]>> {
    return this.http.get<ISibasiHTTPResponse<IAssetRecord[]>>(
      `${environment.api_url}asset/history/all`
    );
  }
  public getPaginatedAssetRecords(
    pagination?: any
  ): Observable<ISibasiHTTPResponse<IPagination<IAssetRecord[]>>> {
    return this.http.post<ISibasiHTTPResponse<IPagination<IAssetRecord[]>>>(
      `${environment.api_url}asset/history/paginated`,
      pagination
    );
  }

  public getAssetRecordById(
    historyId: string
  ): Observable<ISibasiHTTPResponse<IAssetRecord>> {
    return this.http.get<ISibasiHTTPResponse<IAssetRecord>>(
      `${environment.api_url}asset/history/one/${historyId}`
    );
  }

  public deleteAssetRecord(
    historyId: string | undefined
  ): Observable<ISibasiHTTPResponse<IAssetRecord>> {
    return this.http.delete<ISibasiHTTPResponse<IAssetRecord>>(
      `${environment.api_url}asset/history/delete/${historyId}`
    );
  }

  public addBulkAssets(assets: []): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}asset/add/bulk`,
      assets
    );
  }
}
